import { useState, type FC, ChangeEventHandler } from 'react';

import { CheckboxAttribute } from '../../../../types/CheckboxAttribute';
import { CheckBox } from '../../CheckBox';
import { InputText } from '../../InputText';

import styles from './FormListPassword.module.scss';

const checkboxPropsList: CheckboxAttribute[] = [
  {
    id: 'shouldDisplayPassword',
    name: 'shouldDisplayPassword',
    value: 1,
    label: 'パスワードを表示する',
  },
];

type Props = {
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

export const FormListPassword: FC<Props> = ({ onChange }) => {
  const [displayPassword, setDisplayPassword] = useState(false);

  const switchDisplayPassword = () => {
    setDisplayPassword((prevState) => !prevState);
  };

  return (
    <div>
      <span className={styles['wrap-input']}>
        <InputText
          name="password"
          id="password"
          type={displayPassword ? 'text' : 'password'}
          width="default"
          placeholder="半角、英数字を含む8〜16文字以内"
          onChange={onChange}
        />
      </span>
      <span className={styles['wrap-check']}>
        <CheckBox
          columns="default"
          attributes={checkboxPropsList}
          onChange={switchDisplayPassword}
        />
      </span>
    </div>
  );
};
